module.exports = __webpack_public_path__ + "img/pin__pinned.562a7217.svg";